import { buildAdminTaxReceiptHtml } from './taxReceiptHtml.js';

export function openAdminReceiptPrint(receipt, booking) {
  const embedded = receipt?.booking;
  const resolvedBooking = embedded?.batch
    ? {
        ...booking,
        ...embedded,
        joinFromPackage: embedded.joinFromPackage || booking?.joinFromPackage,
        registration: embedded.registration
          ? {
              ...booking?.registration,
              ...embedded.registration,
              package: embedded.registration?.package || booking?.registration?.package
            }
          : booking?.registration,
        batch: embedded.batch || booking?.batch
      }
    : booking;
  const row = { ...receipt, booking: resolvedBooking };
  const html = buildAdminTaxReceiptHtml(row, { origin: window.location.origin });
  const w = window.open('', '_blank', 'width=900,height=1000');
  if (!w) {
    throw new Error('POPUP_BLOCKED');
  }
  w.document.write(html);
  w.document.close();
}

function mapLegacyPaymentMode(mode) {
  const m = String(mode || '').trim().toLowerCase();
  if (m === 'payment_gateway' || m === 'online' || m === 'razorpay' || m === 'upi' || m === 'card') {
    return 'online';
  }
  return 'office';
}

/** Build a booking_receipt-shaped row from a legacy Hasura receipt for printing. */
export function legacyReceiptToPrintableRow(legacy, booking) {
  if (!legacy) return null;
  const paymentId = String(legacy.paymentId ?? legacy.payment_id ?? '').trim();
  return {
    id: legacy.id,
    receiptId: legacy.id,
    amount: legacy.amount,
    receiptNumber: paymentId || String(legacy.id ?? ''),
    paidAt: legacy.createdAt,
    createdAt: legacy.createdAt,
    method: mapLegacyPaymentMode(legacy.paymentMode ?? legacy.payment_mode),
    notes: paymentId ? `Payment ID: ${paymentId}` : null,
    booking
  };
}

export function findBookingReceiptForLegacy(booking, legacy) {
  if (!booking || !legacy?.id) return null;
  const list = Array.isArray(booking.receipts) ? booking.receipts : [];
  return (
    list.find((row) => String(row?.receiptId ?? row?.receipt_id ?? '') === String(legacy.id)) || null
  );
}

export function resolveReceiptRowForPrint(line, booking) {
  if (!line?.printReceipt) return null;
  const receipt = line.printReceipt;
  if (receipt.booking?.batch || receipt.booking?.registration) {
    return receipt;
  }
  return { ...receipt, booking };
}
